import React, {FC, memo, LegacyRef} from "react"
import "lazysizes"
import "lazysizes/plugins/attrchange/ls.attrchange"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/product-summary"
import type {EmblaCarouselType} from "embla-carousel"
import connect from "./connect"
import {SlideDetail} from "./helpers"
import {TextModel} from "../../models/Text"
import {MobileThumbnailConfig} from "../../models/ProductSummary"
import {TemplateSettingsModel} from "../../models/templates"

interface SwiperColourwayImageProps {
    slides: SlideDetail[]
    currentSlideIndex: number
    text: TextModel
    mobileThumbnailConfig: MobileThumbnailConfig
    fetchAdditionalColourchipsThunk: () => void
    template: TemplateSettingsModel
    emblaRef: LegacyRef<HTMLDivElement> | undefined
    emblaApi: EmblaCarouselType | undefined
    thumbsEmblaRef: LegacyRef<HTMLDivElement> | undefined
    thumbsEmblaApi: EmblaCarouselType | undefined
    textAlignment: string
}

export const SwiperColourwayImages: FC<SwiperColourwayImageProps> = memo(props => {
    const {template} = props
    const ComponentName = useTemplatedComponent(template, MANIFEST)

    return <ComponentName {...props} />
})
SwiperColourwayImages.displayName = "SwiperColourwayImages"

export default connect(SwiperColourwayImages)
